import React, { useState } from 'react'
import { MDBAnimation, MDBBtn, MDBIcon, MDBRow, MDBCol, MDBContainer } from 'mdbreact'
import { withRouter } from 'react-router-dom';
import Navbar from '../Navbar';
import FooterWhite from '../FooterWhite';
import { HashLink } from 'react-router-hash-link';

const SearchPage = ({history}) => {
    const [search, setSearch] = useState('');

    const onChange = e => setSearch(e.target.value)
    const onSubmit = e => {
        e.preventDefault();
        history.push(`/search/${search}`)
    }

    return (
        <>
        <Navbar page="Search Blog"/>
        <div id="search-blog" className="d-flex justify-content-center my-5 py-5">
        <MDBAnimation type="slideInUp">
            <form onSubmit={(e)=>onSubmit(e)}>
                <div className="d-none d-md-inline d-lg-inline">
                    <div className="d-flex">
                        <div>
                            <input required name="search" value={search} onChange={(e)=>onChange(e)} type="text" placeholder="Find blogs, keywords: Title, Content, Category. Ex: 'Two and a half men'" style={{ borderRadius: 0, border: `1px solid #000`, width: 700 }} className="form-control form-control-lg" />
                        </div>
                        <div>
                            <MDBBtn type="submit" color="dark" className="text-capitalize m-0 mx-4">
                                Search
                            </MDBBtn>
                        </div>
                    </div>
                </div>
                <MDBContainer className="d-md-none d-lg-none d-inline-block">
                    <MDBRow>
                        <MDBCol size="10"> 
                            <input 
                                required 
                                name="search" 
                                value={search} 
                                onChange={(e)=>onChange(e)} 
                                type="text" 
                                placeholder="Find Blogs" 
                                className="form-control form-control-lg input-custom w-100"
                                />
                        </MDBCol>
                        <MDBCol size="2" className="align-self-center px-0">
                            <button className="p-0 m-0" style={{ background: `transparent`, border: 0 }} type="submit">
                                <MDBIcon className="cursor-pointer-style" size="2x" icon="search"/>
                            </button>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </form>
        </MDBAnimation>   
        </div>
        <MDBContainer fluid className="px-0 pt-5">
            <section className="p-5 grey lighten-4">
                <MDBRow className="py-5 justify-content-center">
                    <MDBCol md="10" lg="8">
                        <div className="text-center">
                            <h2 style={{ lineHeight: 1.5 }} className="h2-responsive font-weight-bold">Got Something in Mind?</h2>
                            <p className="lead">Interested in a specific content? Don't worry we got your back! Give us a call between 10am - 7pm at +63 919 9239 29. We speak English, Tagalog and Cebuano. Just let us know what you need.</p>
                            <HashLink to="/contact#contact-us">
                                <MDBBtn color="dark" className="text-capitalize">
                                    Send Message <MDBIcon fas icon="arrow-right ml-2"/>
                                </MDBBtn>
                            </HashLink>
                        </div>
                    </MDBCol>
                </MDBRow>
            </section>
        </MDBContainer>
        <FooterWhite/>
        </>
    )
}

export default withRouter(SearchPage)
